'use client'

import { Button } from '@progress/kendo-react-buttons'
import { FileQuestion, House } from 'lucide-react'
import { useRouter } from 'next/navigation'

const NotFound: React.FC = () => {
  const router = useRouter()

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: '70vh', padding: '2rem' }}
    >
      <FileQuestion size={72} className="text-primary" style={{ opacity: 0.9 }} />
      <h1 className="fw-semibold mt-4 mb-2" style={{ color: '#093f70' }}>
        Página no encontrada
      </h1>
      <p className="text-muted mb-4" style={{ maxWidth: 440 }}>
        No se pudo encontrar la página indicada. Es posible que el enlace esté roto o que la página haya sido movida.
      </p>
      <div className="d-flex flex-wrap justify-content-center gap-2">
        <Button themeColor="base" onClick={() => router.back()}>
          Volver
        </Button>
        <Button themeColor="primary" onClick={() => router.push('/')}>
          <House size={16} className="align-middle me-1" style={{ flexShrink: 0 }} />
          Ir al inicio
        </Button>
      </div>
    </div>
  )
}

export default NotFound
